module.exports = __webpack_public_path__ + "static/img/irole.0378fb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/zxrx/irole.png
// module id = wORZ
// module chunks = 7